import _slicedToArray from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import React from "react";
var __jsx = React.createElement;
import { useState } from "react";
import useBulkCsvUpload from "../../hooks/useBulkCsvUpload";
import Modal from "../common/Modal";
import classNames from "classnames";
import UploadCsv from "./tabs/UploadCsv";
import AddUser from "./tabs/AddUser";
import AwesomeIcon from "../AwesomeIcon";
import { faXmark } from "@fortawesome/pro-regular-svg-icons";
var TABS = [{
  id: 0,
  label: "Add Single User"
}, {
  id: 1,
  label: "Bulk Upload Users"
}];
function ModalBody() {
  var _useBulkCsvUpload = useBulkCsvUpload(),
    _useBulkCsvUpload2 = _slicedToArray(_useBulkCsvUpload, 2),
    state = _useBulkCsvUpload2[0],
    dispatch = _useBulkCsvUpload2[1];
  var _useState = useState(0),
    activeTab = _useState[0],
    setActiveTab = _useState[1];
  return /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex bg-gray-200 dark:bg-gray-900"
  }, TABS.map(function (tab) {
    return /*#__PURE__*/React.createElement("div", {
      key: tab.id,
      className: classNames("grow hover:text-gray-900 dark:hover:text-gray-100 font-semibold text-gray-600 dark:text-gray-300", {
        "bg-gray-200 dark:bg-gray-900 border-b border-teal-500 text-teal-600 dark:text-teal-400": activeTab === tab.id
      })
    }, /*#__PURE__*/React.createElement("button", {
      className: "h-full w-full px-7 py-5 text-[14px]",
      onClick: function onClick() {
        return setActiveTab(tab.id);
      }
    }, tab === null || tab === void 0 ? void 0 : tab.label));
  })), /*#__PURE__*/React.createElement("div", {
    className: "grow h-[400px] bg-white dark:bg-gray-900"
  }, activeTab === 0 && /*#__PURE__*/React.createElement(AddUser, {
    workspace: state === null || state === void 0 ? void 0 : state.viewData.workspace
  }), activeTab === 1 && /*#__PURE__*/React.createElement(UploadCsv, {
    workspace: state === null || state === void 0 ? void 0 : state.viewData.workspace
  })));
}
function BulkCsvUploadModal() {
  var _useBulkCsvUpload3 = useBulkCsvUpload(),
    _useBulkCsvUpload4 = _slicedToArray(_useBulkCsvUpload3, 2),
    state = _useBulkCsvUpload4[0],
    dispatch = _useBulkCsvUpload4[1];
  var isVisible = state.view === "visible";
  return /*#__PURE__*/React.createElement(Modal, {
    title: "Add Users",
    show: isVisible,
    closeButton: /*#__PURE__*/React.createElement("button", {
      onClick: function onClick() {
        dispatch({
          type: "hide-modal"
        });
      }
    }, /*#__PURE__*/React.createElement(AwesomeIcon, {
      name: faXmark,
      className: "text-gray-700 hover:text-gray-600 dark:text-gray-200 dark:hover:text-gray-100"
    })),
    className: "w-full sm:w-10/12 md:w-10/12 lg:w-6/12 3xl:w-5/12 sm:!bg-white !bg-white sm:dark:!bg-gray-800 dark:!bg-gray-900 h-[80%] flex flex-col sm:h-auto overflow-hidden"
  }, /*#__PURE__*/React.createElement(ModalBody, null));
}
export default BulkCsvUploadModal;